import { VendorContactsListAdmin } from '../../../components/Vendor';

export function VendorContacts() {
  return <VendorContactsListAdmin />;
}
